import ILanguage from './ILanguage';

const pt: ILanguage = {
    title: 'Idioma',
    portuguese: 'Português',
    english: 'Inglês',
    spanish: 'Espanhol',
    prev: 'anterior',
    next: 'próxima',
    send: 'Enviar',
    thankYouPageLeftTitle: 'Pesquisa de satisfacao',
    thankYouPageRightTitle: 'Obrigado',
    thankYouPageText: 'Sua opinião é muito importante para nós!',
    loadingSplashScreenText: 'Carregando...',
    of: 'de',
    developedBy: 'Desenvolvido por',
    requiredField: 'Este campo é obrigatório',
    requiredQuestionLabel: '(obrigatório)',
    optionalQuestionLabel: '(opcional)',
    staticClassForSandbox: 'Classes estáticas para ambiente de teste',
    parameterWarningLabel: 'Adicione o nome e valor do parâmetro no fim da URL como "&<name>=<valor>"',
    AutoCompleteLoadingText: 'Carregando, aguarde',
    AutoCompleteNoOptionsText: 'Nenhuma opção disponível',
    AutoCompleteNoResultsText: 'Nenhum resultado encontrado',
    AutoCompleteRetryTitle: 'Tentar novamente?',
    AutoCompleteSearchPromptText: 'Digite para carregar as opções',
    environmentSandbox: 'Formulário teste, apenas para visualização',
    alreadyCompletedForm: 'Você já preencheu este formulário.',
    form_unavailable_message: 'Ops! Avaliação não disponível no momento',
    form_unavailable_description: 'Essa avaliação não está mais disponível no momento.',
    expired_survey_message: 'Ops! Avaliação expirada',
    expired_survey_description: 'O período para realizar esta avaliação expirou.',
    form_already_answered_message: 'Esta avaliação já foi realizada',
    form_already_answered_description: 'Não é possível realizar esta avaliação novamente.',
    like: 'Gostei',
    dislike: 'Não gostei',
    scoreOption: 'Nota {score}',
    formSubmitted: 'Formulário enviado.',
};

export default pt;
